import OperatingSystem from './OperatingSystem.vue';
export default OperatingSystem;
